export const EMPTY_PROMOTED_GIGS_SUGGESTIONS = {
    gigs: [],
    dlc: '',
    dlc_parent: '',
};

export const PROMOTED_GIGS_COUNT = 4;
